// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"281":"692f7c5ad4a2eea4","887":"470abe57f77cc910"}[chunkId] + ".js";
};